import type { ReactElement } from 'react';

interface FactorLimitBannerProps {
  factorLimit: number;
  enabledFactors: number;
  atFactorLimit: boolean;
  overFactorLimit: boolean;
  tier: string;
  onReset: () => void;
}

export function FactorLimitBanner({
  factorLimit,
  enabledFactors,
  atFactorLimit,
  overFactorLimit,
  tier,
  onReset,
}: FactorLimitBannerProps): ReactElement {
  return (
    <div
      className={`text-xs py-1.5 px-3 rounded-lg mx-1 mb-3 ${overFactorLimit ? 'bg-theme-warning/10 border border-theme-warning/30' : 'bg-theme-surface-hover'}`}
    >
      {overFactorLimit ? (
        <div className="flex items-center justify-between gap-2">
          <span className="text-theme-warning">
            {enabledFactors} factors enabled — your {tier} plan allows {factorLimit}. Reset to
            unlock more.
          </span>
          <button
            type="button"
            onClick={onReset}
            className="shrink-0 text-theme-warning underline hover:no-underline"
          >
            Reset
          </button>
        </div>
      ) : (
        <div className="text-center">
          <span className={atFactorLimit ? 'text-theme-warning' : 'text-purple-400'}>
            {enabledFactors}/{factorLimit} factors enabled
          </span>
          {atFactorLimit && (
            <span className="text-theme-text-tertiary ml-1">— disable one to enable another</span>
          )}
        </div>
      )}
    </div>
  );
}
